import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "./components/HeroCarousel";
import ChannelShortcuts from "./components/ChannelShortcuts";
import HotLives from "./components/HotLives";
import LatestLives from "./components/LatestLives";
import FeaturedStreamers from "./components/FeaturedStreamers";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <section className="w-full px-4 md:px-8 pt-4 md:pt-6">
          <HeroCarousel />
        </section>
        <ChannelShortcuts />
        <HotLives />
        <LatestLives />
        <FeaturedStreamers />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}